const getters = {
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  menuList: state => state.setMenuList.menuList,
  firstMenuInfo: state => state.setMenuList.firstMenuInfo,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js